import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import type { ActivitySummary, CategoryCount } from '@services/activity.service';
import StatCard from './StatCard';

interface AuditSummaryPanelProps {
  summary: ActivitySummary;
  categories: CategoryCount[];
}

const AuditSummaryPanel: React.FC<AuditSummaryPanelProps> = ({ summary, categories }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* MUI's sm/md are 600/900, not Tailwind's 640/768 — arbitrary queries
          keep the original wrap points. */}
      <div className="mb-6 grid grid-cols-1 gap-4 min-[600px]:grid-cols-2 min-[900px]:grid-cols-4">
        <StatCard label={t('audit.totalEvents')} value={summary.total_events.toLocaleString()} />
        <StatCard label={t('audit.activeUsers')} value={summary.unique_users.toLocaleString()} />
        <StatCard label={t('audit.totalAnomalies')} value={summary.anomalies.total} />
        <StatCard label={t('audit.unresolvedAnomalies')} value={summary.anomalies.unresolved} />
      </div>

      <Card className="mb-6 p-4">
        <h6 className="revy-cjk mb-2 text-base font-medium leading-[1.5]">
          {t('audit.eventsByCategory')}
        </h6>
        <div className="flex flex-wrap gap-2">
          {categories.length === 0 && (
            <p className="revy-cjk text-sm leading-[1.6] text-muted-foreground">
              {t('common.noData')}
            </p>
          )}
          {categories.map((category) => (
            <div key={category.action_category} className="m-1 rounded-lg border px-3 py-1">
              <p className="revy-cjk text-xs leading-[1.7]">{category.action_category}</p>
              <p className="revy-figure text-sm font-bold leading-[1.6]">{category.count}</p>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
};

export default AuditSummaryPanel;
